export default __webpack_public_path__ + "static/media/PM.cd943715.webp";